import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import { AgentLeadSourceFormMode, AgentLeadSource } from 'src/app/modules/PulseLeads/types/agent-types';
import { CampaignDropdownList, CampaignDropdownType } from 'src/app/modules/PulseLeads/types/campaign-types';
import { fetchAgentLeadSource } from 'src/app/modules/PulseLeads/network/agentCrud';
import {
  fetchCampaignDropdownList,
  fetchConfig,
  CampaignDropdownListParam,
  ConfigParam,
} from 'src/app/modules/PulseLeads/network/campaignCrud';
import AgentLeadSourceForm from './components/AgentLeadSourceForm';

const AgentLeadSourceDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode } = useMemo(
    () => ({
      formMode: id ? AgentLeadSourceFormMode.EDIT : AgentLeadSourceFormMode.CREATE,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [agentLeadSource, setAgentLeadSource] = useState<AgentLeadSource>();
  const [agentLeadSourceDropdownList, setAgentLeadSourceDropdownList] = useState<CampaignDropdownList>();
  const [config, setConfig] = useState<any>();

  const reloadData = async () => {
    if (id) {
      setIsLoading(true);
      try {
        const res = await fetchAgentLeadSource(id, dispatch);
        setAgentLeadSource(res);
      } catch (err) {
        history.push(NOT_FOUND_ERROR_PAGE_PATH);
      }
    }
    try {
      const params: CampaignDropdownListParam = {
        type: [CampaignDropdownType.AGENT_LEAD_SOURCE],
      };
      const dropdownListRes = await fetchCampaignDropdownList(params, dispatch);
      setAgentLeadSourceDropdownList(dropdownListRes);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const reloadConfig = async () => {
    const configParams: ConfigParam = {
      name: 'sales-sdk',
      namespace: 'default',
    };
    const configRes = await fetchConfig(configParams, dispatch);
    setConfig(configRes.data[0]);
  };

  useEffect(() => {
    reloadConfig();
  }, []);

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [id]);

  return (
    <>
      {formMode === AgentLeadSourceFormMode.CREATE && (
        <AgentLeadSourceForm
          formMode={formMode}
          agentLeadSourceDropdownList={agentLeadSourceDropdownList}
          config={config}
        />
      )}
      {formMode === AgentLeadSourceFormMode.EDIT &&
        (isLoading || !agentLeadSource ? (
          <LayoutSplashScreen />
        ) : (
          <AgentLeadSourceForm
            formMode={formMode}
            agentLeadSource={agentLeadSource}
            agentLeadSourceDropdownList={agentLeadSourceDropdownList}
            config={config}
          />
        ))}
    </>
  );
};

export default AgentLeadSourceDetailPage;
